import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data: [],
    isUpdatingShipment: false,
    status: null,
}

const token = userObj?.token

export const updateShipment = createAsyncThunk(
    'order/updateShipment',
    async (data, { rejectWithValue }) => {

        try {
            const response = await axios.put("/Order/UpdateShipmentCity", data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }

    }
)


const updateShipmentSlice = createSlice({
    name: 'updateShipment',
    initialState,
    reducers: {},
    extraReducers: {
        [updateShipment.pending]: (state, action) => {
            state.status = 'pending';
            state.isUpdatingShipment = true;
        },
        [updateShipment.fulfilled]: (state, action) => {
            state.status = 'success';
            state.isUpdatingShipment = false;
            state.data = action.payload;
        },

        [updateShipment.rejected]: (state, action) => {
            state.status = 'failed';
            state.isUpdatingShipment = false;
        }
    }
})

export default updateShipmentSlice.reducer;
